export const isSelfOnlyScheduleEvent = (event, currentUseruuid) => {
  if (!currentUseruuid || !event) return false;
  const participants = event.invitedcontacts ?? event.invited_contacts;
  if (!Array.isArray(participants) || participants.length !== 1) return false;
  const participant = participants[0];
  return (
    (typeof participant === 'string' ? participant : participant?.useruuid) === currentUseruuid
  );
};
